// Canonical URL utility for managing canonical links across subdomain sites

const { getMetroConfig, DEFAULT_SUBPAGE_MAPPINGS } = require('./metroConfig');

// Generates the canonical URL for a given path and metro data and returns null if no canonical URL should be generated (metro not enabled)
function getCanonicalUrl(pathname, currentMetro) {
    const metroConfig = getMetroConfig(currentMetro.name, currentMetro.stateAbbrev);
    if (!metroConfig?.canonicalEnabled) {
        return null;
    }

    // Handle homepage - points to the metro page on milanlaser.com
    if (pathname === '/') {
        const firstStore = currentMetro.stores && currentMetro.stores[0];
        if (firstStore && firstStore.urlPath) {
            const urlParts = firstStore.urlPath.split('/');
            if (urlParts.length >= 4) {
                const metroPath = urlParts.slice(0, 4).join('/');
                return `https://milanlaser.com${metroPath}`;
            }
        }

        return `https://milanlaser.com${metroConfig.targetPath}`;
    }

    // Handle location-specific pages - points to specific store location page
    if (pathname.startsWith('/locations/') && currentMetro.stores && currentMetro.stores.length > 0) {
        const locationPath = pathname.replace('/locations/', '').replace(/\/$/, '');

        // If it's the metro path, determine canonical based on number of locations
        if (locationPath === currentMetro.metroPath) {
            // Single location: point directly to the clinic page
            if (currentMetro.stores.length === 1) {
                const firstStore = currentMetro.stores[0];
                if (firstStore && firstStore.urlPath) {
                    return `https://milanlaser.com${firstStore.urlPath}`;
                }
            }

            // Multiple locations: point to the metro-level overview page
            return `https://milanlaser.com${metroConfig.targetPath}`;
        }

        // Check for specific store paths - use full urlPath
        const matchingStore = currentMetro.stores.find(
            (store) => locationPath === store.pathname || locationPath.includes(store.pathname)
        );

        if (matchingStore && matchingStore.urlPath) {
            return `https://milanlaser.com${matchingStore.urlPath}`;
        }
    }

    // Check if there's a default mapping for this path
    if (DEFAULT_SUBPAGE_MAPPINGS[pathname]) {
        return DEFAULT_SUBPAGE_MAPPINGS[pathname];
    }

    // If no mapping exists and metro is enabled, return null (no canonical link)
    return null;
}

module.exports = {
    getCanonicalUrl,
};
